import { useEffect, useMemo } from "react";

export default function EmptyPage() {
  const parseQueryString = function (queryString: string) {
    const params = new URLSearchParams(queryString);
    const result: any = {};

    for (let pair of params.entries()) {
      const key = pair[0];
      const value = pair[1];

      result[key] = value;
    }

    return result;
  }

  const parsedURLParams = parseQueryString(window.location.search);
  const message = useMemo(() => parsedURLParams['service-name'] ?? "Service App", [window.location.search]);

  useEffect(() => {
    if (parsedURLParams.closeTab && window.opener) {
      window.opener.postMessage({ reload: true }, "*");
      window.close();
    }
  }, []);

  return (
    <div style={{ padding: "30px" }}>
      <p>You've successfully authenticated to the <b>{message}</b>. </p>
      <p>This window can be closed now or you can navigate to <a href="/dashboard">Arelia Home</a> page.</p>
    </div>
  );
}
